import { useCommonUserProfile } from '@hooks/user';
import { setAfterLogin } from '@libraries/auth';
import KakaoSolid from '@assets/svgs/KakaoSolid.svg';
import ChevronRight from '@assets/svgs/ChevronRight.svg';

export default function LinkingKakaoAccountMenuItem() {
  const { userProfile } = useCommonUserProfile();

  if (!userProfile || userProfile.hasKakaoAccount) {
    return <></>;
  }

  const onClick = () => {
    setAfterLogin({
      redirectTo: location.pathname + location.search,
    });
    window.Kakao.Auth.authorize({
      redirectUri: `${location.origin}/login/third-party/kakao-integration`,
    });
  };

  return (
    <button
      type="button"
      className="w-full rounded-[8px] px-[16px] py-[8px] bg-[#FFEA2B] flex gap-x-[10px] items-center"
      onClick={onClick}
    >
      <KakaoSolid className="w-[20px] h-[20px] content_primary" />
      <p className="font_label_medium_sm content_secondary text-left">
        카카오 계정 연동하고
        <br />
        간편하게 로그인
      </p>
      <ChevronRight className="w-[12px] h-[12px] content_secondary" />
    </button>
  );
}
